import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import cn from 'classnames';

import { useCollapseDrawer } from 'hooks/useCollapseDrawer';
import { NavbarVertical } from './navbar/NavbarVertical';

import s from './styles.module.scss';

export const DashboardLayout = () => {
  const { opened, hovered } = useCollapseDrawer();

  return (
    <Box
      sx={{
        display: { lg: 'flex' },
        minHeight: { lg: 1 },
        height: '100%',
      }}
    >
      <main className={cn(s.main, { [s.closed]: !opened, [s.hovered]: !opened && hovered })}>
        <Outlet />
      </main>

      <NavbarVertical />
    </Box>
  );
};
